import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import { getInnerHTMLFormat } from '../../../helpers/utils';
import Poster from './Poster/Poster';
import Style from '../../../styles/common';

const Container = styled('section')`
  align-items: center;
  background-color: ${Style.color.detailHeaderBackground};
  display: flex;
  flex-direction: column;
  height: 400px;
  justify-content: flex-end;
`;

const Content = styled('div')`
  display: flex;
  max-width: 900px;
  width: ${Style.size.width.detailContentWidth};
`;

const HeaderText = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-left: 3rem;
  padding-bottom: 2rem;
`;

const Title = styled('h1')`
  color: ${Style.color.eventDetailTitle};
  font-family: ${Style.FONT_FAMILY.DEFAULT};
  font-size: 1.5rem;
  font-weight: ${Style.FONT_WEIGHT.SEMI_BOLD};
  line-height: 1.5;
  margin-top: 0;
`;

const Location = styled('span')`
  color: ${Style.color.lightText};
  
  a {
    color: ${Style.color.lightText};
  }
`;

function DetailHeader(props) {
  return (
    <Container>
      <Content>
        <Poster
          imageUrl={props.imageUrl}
        />
        <HeaderText>
          <Title {...getInnerHTMLFormat(props.title)} />
          <Location {...getLocation(props.location)} />
        </HeaderText>
      </Content>
    </Container>
  );
}

function getLocation(loc) {
  if (!loc) {
    return '';
  }

  return getInnerHTMLFormat(loc.replace('<br />', ' '));
}

DetailHeader.propTypes = {
  imageUrl: PropTypes.string,
  location: PropTypes.string,
  title: PropTypes.string,
};

DetailHeader.defaultTypes = {
  imageUrl: '',
  location: '',
  title: '',
};

export default DetailHeader;



// WEBPACK FOOTER //
// ./src/views/Detail/DetailHeader/DetailHeader.js